import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTE_PATH } from '@/constants/routes';

interface SignUpCompleteFormProps {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

export const SignUpCompleteForm = ({
  email,
  firstName,
  lastName,
  password,
}: SignUpCompleteFormProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleStartUsing = () => {
    navigate(ROUTE_PATH.LOGIN);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <section className="l-card">
      <h2 className="l-card__title">{t('signupComplete.confirmationTitle')}</h2>
      <div className="l-card__body">
        <div className="l-box">
          <div className="mypage-detail">
            {/* メールアドレス */}
            <div className="mypage-detail__row mypage-detail__row--email">
              <div className="mypage-detail__label">
                {t('signupComplete.email')}
              </div>
              <div className="mypage-detail__value">{email}</div>
            </div>
            {/* 氏名 */}
            <div className="mypage-detail__row mypage-detail__row--name">
              <div className="mypage-detail__name-grid">
                <div className="mypage-detail__label mypage-detail__label--lastname">
                  {t('signupComplete.lastName')}
                </div>
                <div className="mypage-detail__label mypage-detail__label--firstname">
                  {t('signupComplete.firstName')}
                </div>
                <div className="mypage-detail__value mypage-detail__value--lastname">
                  {lastName}
                </div>
                <div className="mypage-detail__value mypage-detail__value--firstname">
                  {firstName}
                </div>
              </div>
            </div>
            {/* パスワード */}
            <div className="mypage-detail__row mypage-detail__row--password">
              <div className="mypage-detail__label">
                {t('signupComplete.password')}
              </div>
              <div className="mypage-detail__value-wrapper">
                <div
                  className="mypage-detail__value mypage-detail__value--password"
                  data-password={password}
                  data-password-hidden={!isPasswordVisible}
                >
                  {isPasswordVisible ? password : '＊＊＊＊＊＊＊＊＊＊＊＊'}
                </div>
                <button
                  type="button"
                  className="mypage-detail__toggle-password"
                  onClick={togglePasswordVisibility}
                >
                  <img
                    src="/Common_Icon_eye_open.png"
                    alt={t('common.altText.openEye')}
                    className="mypage-detail__toggle-icon mypage-detail__toggle-icon--open"
                  />
                  <img
                    src="/Common_Icon_eye_close.png"
                    alt={t('common.altText.closeEye')}
                    className="mypage-detail__toggle-icon mypage-detail__toggle-icon--close"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="actions">
          <a
            href="#"
            className="link-button link-button--reserve-started"
            onClick={(e) => {
              e.preventDefault();
              handleStartUsing();
            }}
          >
            {t('signupComplete.startButton')}
          </a>
        </div>
      </div>
    </section>
  );
};
